module.exports = __webpack_public_path__ + "ecosystem_go-v.99892ef3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/ecosystem_go-v.png
// module id = 2590
// module chunks = 0